import { ArrowDownIcon, ArrowUpIcon, Button, Flex, Skeleton } from "@fluentui/react-northstar";
import { memo } from "react";
import { useTable } from "./Table.logic";
import { flexRender } from "@tanstack/react-table";
import "./Table.css";
import { ChevronsLeft, ChevronsRight } from "lucide-react";
import { TablePagination } from "front";

const Table = () => {
  const logic = useTable();

  if (logic.isLoading)
    return (
      <Flex vAlign="center" hAlign="center" space="between" style={{ marginTop: "2rem" }} fill>
        <Flex fill>
          <Skeleton animation="pulse">
            <Skeleton.Input style={{ minHeight: "50px", width: "100%" }} />
            <Skeleton.Input style={{ minHeight: "40px", width: "100%", marginTop: ".1rem" }} />
            <Skeleton.Input style={{ minHeight: "60px", width: "100%", marginTop: ".1rem" }} />
            <Skeleton.Input style={{ minHeight: "60px", width: "100%", marginTop: ".1rem" }} />
            <Skeleton.Input style={{ minHeight: "60px", width: "100%", marginTop: ".1rem" }} />
            <Skeleton.Input style={{ minHeight: "60px", width: "100%", marginTop: ".1rem" }} />
            <Skeleton.Input style={{ minHeight: "60px", width: "100%", marginTop: ".1rem" }} />
            <Flex hAlign="end">
              <Skeleton.Input style={{ minHeight: "20px", width: "175px", marginTop: ".25rem" }} />
            </Flex>
          </Skeleton>
        </Flex>
      </Flex>
    );

  return (
    <Flex style={{ margin: ".5rem 0 1rem 0" }} column>
      {logic.tableLength > 0 ? (
        <Flex fill style={{ width: "100%" }} column>
          <TablePagination table={logic.table} MAXIMUM_PAGINATION_LENGTH={logic.MAXIMUM_PAGINATION_LENGTH} generatePaginationStructure={logic.generatePaginationStructure} shouldDisplay={logic.shouldDisplay} />
          <Flex fill style={{ width: "100%", padding: "1rem 0" }} column>
            <table className="table-table">
              <thead className="table-header">
                {logic.table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                      return (
                        <th key={header.id} onClick={() => header.column.toggleSorting(header.column.getIsSorted() === "asc")} className="table-head-th">
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {header.column.getIsSorted() ? (
                            header.column.getIsSorted() === "asc" ? (
                              <ArrowUpIcon size="smaller" style={{ marginLeft: ".25rem" }} />
                            ) : (
                              <ArrowDownIcon size="smaller" style={{ marginLeft: ".25rem" }} />
                            )
                          ) : (
                            <>{header.column.getCanSort() ? <ArrowDownIcon size="smaller" style={{ marginLeft: ".25rem" }} /> : <></>}</>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              {/* Test ids: this component replaced DisplayByList as the LIST display mode and shipped
                  without any, so the suite could only assert on Fluent internals. Kebab-case and
                  component-scoped, per .claude/rules/08-testing-conventions.md. */}
              <tbody data-testid="table-users-container">
                {logic.table.getRowModel().rows.map((row, i) => {
                  return (
                    <tr
                      key={row.id}
                      className={"table-rows"}
                      data-testid="table-user-row"
                      style={{ animation: `fadeIn calc(0.2s * ${i})` }}
                      onClick={() => logic.editContact(row.original.id, false)}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                {logic.table.getFooterGroups().map((footerGroup) => (
                  <tr key={footerGroup.id}>
                    {footerGroup.headers.map((header) => (
                      <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.footer, header.getContext())}</th>
                    ))}
                  </tr>
                ))}
              </tfoot>
            </table>
          </Flex>
          <TablePagination table={logic.table} MAXIMUM_PAGINATION_LENGTH={logic.MAXIMUM_PAGINATION_LENGTH} generatePaginationStructure={logic.generatePaginationStructure} shouldDisplay={logic.shouldDisplay} />
        </Flex>
      ) : (
        <></>
      )}
    </Flex>
  );
};

export default memo(Table);
